import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import Pagination from  '../../../components/Pagination/Pagination';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { API } from 'aws-amplify';
import Moment from 'react-moment';
import moment from 'moment';
import { Link } from 'react-router-dom';

const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const DeviceList = (props) => {
    const [assets, setAssets] = useState([]);
    const [assetList, setAssetList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage] = useState(100);
	const [asset,setAsset] = useState('');
    const [locationList, setLocationList] = useState([]);
    const [countryList, setCountryList] = useState([]);
	const [location, setLocation] = useState('');
	const [country, setCountry] = useState('');
	const [status, setStatus] = useState('');

    let formatDate = ['DD-MM-YYYY','dd/MM/yyyy']
    if (props.formatDate!==formatDate[0]){
        formatDate = ['MM-DD-YYYY','MM/dd/yyyy']
    }

    // Load asset
    /* eslint-disable no-alert, no-console */
    useEffect(()=>{
        const fetchAssets = async () => {
            setIsLoading(true);

            const data = await API.get('list_asset','/', params)
            data.sort((a, b) => (a.location > b.location) ? 1 : -1)

            //Get user asset list
            // let user_assets = []
            // user_assets = await API.get('user_assets','/' + props.user.username, params)
            let user_assets = props.user.user_assets || []

            let assetsFiltered = []
            if (user_assets){
                // user_assets = user_assets.assets;
                assetsFiltered = data.filter(x => user_assets.find(i => i === x.id) && x.status === 'active');
            }

            assetsFiltered.map(x => moment(x.last_update).isSameOrAfter(new Date(), "day") ? x.css = "text-dark"  : x.css = "text-danger")

            if (assetsFiltered.length>0){
                setAssets(assetsFiltered);
                setAssetList(assetsFiltered);
            }

            setIsLoading(false);
        }

    if (props.user && props.user.user_assets)
        fetchAssets();

    }, [props.user]);

    // // Load location
	// useEffect(()=>{
	// 	const fetchLocation = async () => {
    //         const loc = [...new Set(assets.map(item => item.location))];
	// 		setLocationList(loc);
	// 	}
    //     fetchLocation();
    // }, [assets]);

    // Load country
	useEffect(()=>{
		const fetchCountry = async () => {
            let loc = [...new Set(assets.map(item => item.country))];
            loc = loc.filter(item => item !== undefined);
            loc.sort((a, b) => (a > b) ? 1 : -1)

            if (loc.length === 1)
                setCountry(loc[0]);

			setCountryList(loc);
		}
        fetchCountry();

    }, [assets]);

    // Load location
	useEffect(()=>{
		const fetchLocation = async () => {
            let loc=[]
            if (country){
                loc = [...new Set(assets.filter(item => item.country === country).map(item => item.location))];
            }else{
                loc = [...new Set(assets.map(item => item.location))];
            }
            loc = loc.filter(item => item !== undefined);
            loc.sort((a, b) => (a > b) ? 1 : -1)
			setLocationList(loc);
		}
        fetchLocation();
    }, [assets, country]);

    useEffect(() => {
        const handleSearch = () => {
            let results = assets;
            // Site Reference
            if (asset){
                results = results.filter(results =>
                    (results.name && results.name.toLowerCase().includes(asset.toLowerCase())) ||
                    (results.address && results.address.toLowerCase().includes(asset.toLowerCase())))
            }
            // country
            if (country){
                results = results.filter(results =>
                    results.country && results.country.toLowerCase().includes(country.toLowerCase())
            )}
            // Location
            if (location){
                results = results.filter(results =>
                    results.location && results.location.toLowerCase().includes(location.toLowerCase())
            )}
            // status
            if (status){
                results = results.filter(results =>
                    results.css && results.css.includes(status)
            )}
            setAssetList(results);
            paginate(1);
        }
		handleSearch();
    }, [location, country, asset, assets, status]);

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItemList = assetList.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = pageNumber => setCurrentPage(pageNumber);

    return (

        <div className="DeviceList">
            <div className="col-md-12">
                <div className="row header pb-0">
                    <div className="col-4">Data Update</div>
                    <div className="col-8 d-flex justify-content-end">
                        <div className="p-2"><h3>Assets</h3></div>
                        <div className="col-md-12">
                            <div className="row">
                            <Form.Group controlId="site_ref" className="col-md-4 ps-4">
                            <Form.Control
                                as="input"
                                value={asset}
                                onChange={e => {setAsset(e.target.value)}}
                                type="text" />
                            </Form.Group>
                            <Form.Group controlId="country" className="col-md-3">
                            <Form.Control
                                as="select"
                                value={country}
                                onChange={e => {setCountry(e.target.value)}}>
                                    <option value="">Country</option>
                                    {countryList.map((item, i) =>
                                        <option key={`country`+i} value={item}>{item}</option>
                                        )}

                            </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="location" className="col-md-3">
                                <Form.Control
                                    as="select"
                                    value={location}
                                    onChange={e => {setLocation(e.target.value)}}>
                                        <option value="">Location</option>
                                        {locationList.map((item, i) =>
                                            <option key={`loc`+i} value={item}>{item}</option>
                                            )}

                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="status" className="col-md-2">
                                <ToggleButtonGroup type="radio" name="options" value={status} >
                                    <ToggleButton variant="outline-secondary" className="px-2" value="" onClick={() => setStatus('')} >
                                        All
                                    </ToggleButton>
                                    <ToggleButton variant="outline-success" className="px-2" value="text-dark" onClick={() => setStatus('text-dark')} >
                                        Active
                                    </ToggleButton>
                                    <ToggleButton variant="outline-danger" className="px-2" value="text-danger" onClick={() => setStatus('text-danger')} >
                                        Alert
                                    </ToggleButton>
                                </ToggleButtonGroup> 
                            </Form.Group>
                            </div>
                        </div>
                    </div>


                </div>
                <div className="row">
			        <div className="col-md-12 div-content">
                        {(!isLoading) ? (
                        (currentItemList.length === 0) ?  (
                        //     <div className="col-md-12 p-4 text-center text-secondary">No records found</div>
                        ''
                        ):(
                        <div>
                        <Table responsive bordered hover size="sm" variant="light">
                        <thead>
                            <tr>
                            <th className='border-bottom'>Asset</th>
                            <th className='border-bottom'>Country</th>
                            <th className='border-bottom'>Location</th>
                            <th className='border-bottom'>Last Update</th>
                            </tr>
                        </thead>
                        <tbody>
                        {currentItemList.map((item, i) => (
                        <tr key={i} className="table-tr">
                            <td className="border-bottom" key={item.id}>
                                <Link to={`/device_det/${item.id}`} className="link">
                                    {item.name}
                                </Link>
                            </td>
                            <td className="border-bottom">{ item.country }</td>
                            <td className="border-bottom">{ item.location }</td>
                            <td className="border-bottom">
                                {item.last_update ?
                                (<Moment local format={formatDate[0] + " HH:mm:ss"} date={ item.last_update } className={ item.css } />)
                                : ''}
                            </td>
                        </tr>
                        ))}
                        </tbody>
                        </Table>

                        <Pagination
                            sizePerPage={itemsPerPage}
                            currentPage={currentPage}
                            totalSize={assetList.length}
                            changeCurrentPage={paginate}
                            theme="bootstrap"
                        />
                    </div>
                    )):(
                        <div className="col-md-12">
                        <Spinner animation="grow" size="sm" role="status" variant="warning" />
                        <span className="text-dark">  Loading...</span>
                        </div>
                    )}
                    </div>
		        </div>
            </div>

        </div>
    )
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
    };
  };

export default connect(mapStateToProps)(DeviceList);
